import { apiRequest } from '../api/client';

export const memberSettingsApi = {
  getSettings: () => apiRequest('/settings'),
};
